export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In corso"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Completato"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In attesa"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Prossimo"])}
}